import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-random-cascade',
  templateUrl: './random-cascade.component.html',
  styleUrls: ['./random-cascade.component.scss']
})
export class RandomCascadeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
